import {
    addCalendarProviderAccount,
    calendarProviderAccountAdded,
    errorInAddingCalendarProviderAccount,
} from '../actions/publicActions';
import { getOAuthProviderType } from '../utils/calendarProviderTypeConverter';
import { allSupportedCalendarProviderTypes } from '../store/schema/CalendarProviderType';
import {
    lazyLinkAccountAndGetAccessToken,
    lazySetAddConnectedAccountHandler,
} from 'owa-link-account';
import { orchestrator } from 'satcheljs';
import type { CalendarProviderAccountInfo } from '../types/CalendarProviderAccountInfo';
import { trace } from 'owa-trace';
import { createCalendarProviderAccount } from '../utils/createCalendarProviderAccount';
import {
    addCalendarProviderAccountHandler,
    ConnectedAccountResponseWithObj,
} from '../utils/addCalendarProviderAccountHandler';

orchestrator(addCalendarProviderAccount, async actionMessage => {
    const { providerType } = actionMessage;

    const oauthProviderType = getOAuthProviderType(providerType);
    try {
        const response = (await lazyLinkAccountAndGetAccessToken.importAndExecute(
            oauthProviderType
        )) as ConnectedAccountResponseWithObj<CalendarProviderAccountInfo>;
        const calendarProviderAccount = createCalendarProviderAccount(
            response.connectedAccountObject
        );

        calendarProviderAccountAdded(calendarProviderAccount);
    } catch (error) {
        trace.warn(
            `Error when adding calendar provider account of type \"${providerType}\": ${error.toString()}`
        );
        errorInAddingCalendarProviderAccount(providerType);
    }
});

export function initializeCalendarProviderAccountAddHandlers() {
    allSupportedCalendarProviderTypes
        .map(getOAuthProviderType)
        .map(oauthProviderType =>
            lazySetAddConnectedAccountHandler.importAndExecute(
                oauthProviderType,
                addCalendarProviderAccountHandler(oauthProviderType)
            )
        );
}
